import { cn } from "@/utils/cn";
import type { ReactNode } from "react";

interface SettingsPanelProps {
  id: string;
  title: string;
  description?: string;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
  labelledBy?: string;
}

export function SettingsPanel({
  id,
  title,
  description,
  actions,
  children,
  className,
  labelledBy,
}: SettingsPanelProps) {
  const headingId = labelledBy ?? `${id}-heading`;

  return (
    <section
      id={id}
      aria-labelledby={headingId}
      className={cn("card p-6 sm:p-8", className)}
    >
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="max-w-2xl">
          <h2
            id={headingId}
            className="text-base font-semibold text-slate-900 dark:text-slate-100"
          >
            {title}
          </h2>
          {description && (
            <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
              {description}
            </p>
          )}
        </div>
        {actions && (
          <div className="flex shrink-0 flex-wrap gap-2">{actions}</div>
        )}
      </div>
      <div className="mt-6">{children}</div>
    </section>
  );
}
